/**
 * Supervisory note (Phase 19 F21): only on a SUPERVISORY visit.
 */

import { BaseEntryData } from './chart-entry.dto';
import type { EntryVisibility } from './general-note.dto';
import { disciplineEntries, providerTypeEntries } from '../../../constants/disciplines';

/** LVN, HHA, RN, (Phase 20C) the therapy assistants (PTA, COTA, SLPA) and (Phase 20D) attendants */
export const SUPERVISED_DISCIPLINES: readonly string[] = Object.freeze([...new Set([
  'LVN', 'HHA', 'RN', ...providerTypeEntries().filter((p) => p.role === 'assistant').map((p) => p.code),
  ...disciplineEntries().filter((d) => d.aideTasks).map((d) => d.code),
])]);
export type SupervisedDiscipline = string;

export const POC_FOLLOWED = ['YES', 'NO', 'PARTIAL'] as const;
export type PocFollowed = typeof POC_FOLLOWED[number];

export const CLIENT_SATISFACTION = ['SATISFIED', 'CONCERNS', 'NOT_ASSESSED'] as const;
export type ClientSatisfaction = typeof CLIENT_SATISFACTION[number];

/** Competencies offered in the form; the server stores the list as given */
export const SUPERVISION_COMPETENCIES = [
  'INFECTION_CONTROL',
  'MEDICATION_ADMINISTRATION',
  'TRACH_CARE',
  'VENTILATOR_MANAGEMENT',
  'SUCTIONING',
  'G_TUBE_FEEDING',
  'SEIZURE_PRECAUTIONS',
  'PERSONAL_CARE',
  'SAFETY_AND_TRANSFERS',
  'DOCUMENTATION',
  'COMMUNICATION',
] as const;

export interface SupervisoryNoteData extends BaseEntryData {
  /** A staff user in the tenant */
  supervisedUserId: string;
  supervisedDiscipline: SupervisedDiscipline;
  staffPresent: boolean;
  pocFollowed: PocFollowed;
  competenciesObserved?: string[];
  clientSatisfaction?: ClientSatisfaction;
  issues?: string;
  actions?: string;
  /** YYYY-MM-DD */
  nextDueDate?: string;
  visibility?: EntryVisibility;
}
